import React from "react";
import { ElementComponentProps } from "elements/types";
import { useDisplayElement } from "components/Forms/Element";
import { useSelector } from "react-redux";
import { State } from "data";
import { getOrigElementData } from "data/form/elementSelectors";
import { ParagraphElement } from "records/Element";

const Paragraph = ({
	fid,
	uuid,
	rowIndex,
	id,
	index,
	value,
	vid,
}: ElementComponentProps<ParagraphElement>) => {
	const { eid } = useDisplayElement({ rowIndex, index, uuid });

	const _value = useSelector((state: State) => {
		if (!id) return value;
		return getOrigElementData(state, {
			fid,
			vid,
			uuid,
			rowIndex,
			id,
			index,
		})?.value;
	});

	return (
		<p className="elem elem-paragraph" id={eid}>
			{_value}
		</p>
	);
};

export default React.memo(Paragraph);
